<template>
  <b-form-group>
    <label :class="{'required': required}"><slot/></label>
    <b-form-input v-bind="$attrs"
                  v-on="$listeners"
                  :value="value"
                  :class="addClass"
                  @input="$emit('input', $event)">
    </b-form-input>
  </b-form-group>
</template>

<script>
export default {
  name: 'TextBox',
  props: {
    value: '',
    required: false,
    addClass: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/TextBox.vue